import { Box, Grid, Link, Paper, TablePagination, Typography } from "@mui/material";
import { useMemo, useState } from "react";
import DisplayContadores from "../../../../../../components/DisplayContadores";
import { formatarValorMonetario } from "../../../../../../helpers/masks";
import tratativaDeDatas from "../../../../../../helpers/tratativaDeDatas";
import DialogDetalheFechamento from "../DialogDetalheFechamento";
import { useQuery } from "react-query";
import axiosClient from "../../../../../../lib/axios";
import { TFechamentos } from "../../../../../../types/api/financeiro/pesquisar-fechamentos";
import LoadingApiQuery from "../../../../../../components/LoadingApiQuery";

export default function UltimosFechamentos() {

    const [openDetalheModal, setOpenDetalheModal] = useState<number | null>(null)
    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(6);

    //queries e mutations
    const { data, isFetching } = useQuery({
        queryKey: ['pesquisar-ultimos-fechamentos', page, limit],
        queryFn: () => axiosClient.get("/financeiro/conta-corrente-consumo/pesquisar-fechamentos", {
            params: {
                status_contem: ['Fechado', 'Cancelado'],
                page,
                limit: limit,
            }
        }),
        cacheTime: 0,
        keepPreviousData: true,
        refetchOnWindowFocus: false
    });

    const dataUltimosFechamentos: TFechamentos[] = useMemo(() => data?.data.data || [], [data])
    //

    // funções de paginação
     const handleChangePage = (_: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeLimit = (event: React.ChangeEvent<HTMLInputElement>) => {
        setLimit(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <>
            <Box component={Paper} p={2}>
                <Typography variant="h6">Últimos fechamentos</Typography>

                {
                    isFetching &&
                    <LoadingApiQuery />
                }
                {
                    !isFetching && dataUltimosFechamentos.length === 0 &&
                    <Box display={'flex'} width={'100%'} justifyContent={'center'} m={4} >
                        <Typography variant="body1" sx={{ opacity: 0.6 }}>Nenhum fechamento encontrado</Typography>
                    </Box>
                }
                <Grid container spacing={2}>
                    {
                        !isFetching && dataUltimosFechamentos.length > 0 &&
                        dataUltimosFechamentos.map((item, index) => (
                            <Grid key={index} size={{xs: 12, sm: 6}}>
                                <Box display={'flex'} gap={2} mt={2}>
                                    <Box display={'flex'} flexDirection={'column'} justifyContent={'flex-start'}>
                                        <Box
                                            mt={0.5}
                                            width={17}
                                            height={17}
                                            bgcolor={'darkgray'}
                                            borderRadius={'50%'}
                                        ></Box>
                                    </Box>

                                    <Box display={'flex'} flexDirection={'column'} justifyContent={'flex-start'}>
                                        <Typography variant="body1">
                                            <b>{item.nome}</b>
                                        </Typography>
                                        {
                                            item.status !== 'Cancelado' &&
                                            <Typography
                                                variant="subtitle2"
                                                mb={1}
                                                sx={{ opacity: 0.6 }}
                                            >
                                                Fechado em {tratativaDeDatas(item.data_fechamento)}
                                            </Typography>
                                        }
                                        {
                                            item.status === 'Cancelado' &&
                                            <Typography
                                                color='error'
                                                variant="subtitle2"
                                                mb={1}
                                            >
                                                Cancelada em {tratativaDeDatas(item.detalhes.cancelado_em)}
                                            </Typography>
                                        }
                                        <DisplayContadores
                                            titulo="Qtd. faturas"
                                            valor={`${item.detalhes.qtd_faturas}`}
                                            marginY={0}
                                        />
                                        <DisplayContadores
                                            titulo="Créditos"
                                            valor={formatarValorMonetario(item.detalhes.creditos)}
                                            marginY={0}
                                        />
                                        <DisplayContadores
                                            titulo="Débitos"
                                            valor={formatarValorMonetario(item.detalhes.debitos)}
                                            marginY={0}
                                        />
                                        <DisplayContadores
                                            titulo="Total"
                                            valor={formatarValorMonetario(Math.abs(item.detalhes.total))}
                                            marginY={0}
                                        />

                                        <Link
                                            onClick={() => setOpenDetalheModal(item.id)}
                                        >
                                            <Typography
                                                variant="caption"
                                                sx={{ cursor: 'pointer' }}
                                            >
                                                Ver detalhes
                                            </Typography>
                                        </Link>
                                    </Box>
                                </Box>
                            </Grid>
                        ))
                    }

                    <Grid size={{xs: 12}}>
                        <TablePagination
                            component="div"
                            count={data?.data.total || 0}
                            page={page}
                            onPageChange={handleChangePage}
                            rowsPerPage={limit}
                            onRowsPerPageChange={handleChangeLimit}
                            rowsPerPageOptions={[6, 12, 18, 24, 30]}
                            labelRowsPerPage="Linhas por página:"
                            labelDisplayedRows={({ from, to, count }) =>
                                `${from}-${to} de ${count !== -1 ? count : `mais de ${to}`}`
                            }
                        />
                    </Grid>
                </Grid>
            </Box>

            {
                openDetalheModal &&
                <DialogDetalheFechamento
                    id={openDetalheModal}
                    open={Boolean(openDetalheModal)}
                    onClose={() => setOpenDetalheModal(null)}
                />
            }
        </>
    )
}